import list from 'src/modules/recyclingMaterials/list/recyclingMaterialsListReducers';
import form from 'src/modules/recyclingMaterials/form/recyclingMaterialsFormReducers';
import view from 'src/modules/recyclingMaterials/view/recyclingMaterialsViewReducers';
import destroy from 'src/modules/recyclingMaterials/destroy/recyclingMaterialsDestroyReducers';
import importerReducer from 'src/modules/recyclingMaterials/importer/recyclingMaterialsImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
